<!--  -->
<template>
  <div v-loading="loadingtable" class="tactics_box">
    <el-form label-position="right" label-width="100px">
      <el-form-item label="策略标题">
        <el-input v-model="sp_strategy_title" placeholder="请输入策略标题" class="stra_box" />
      </el-form-item>
      <el-form-item label="触发条件">
        <!--  @change="spchanger" -->
        <el-radio-group v-model="sp_strategy_type">
          <el-radio-button v-for="(item,i) in sparr" :key="i" :disabled="type===2" :label="i">{{ item }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发送方式" style="margin-bottom:40px">
        <el-radio-group v-model="push_method" @change="spchangerr">
          <el-radio-button v-for="(item,i) in accountarrsa" :key="i" :disabled="i==='1'||type===2" :label="i">{{ item }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <div style="margin-bottom: 50px;">
        <el-button size="mini" icon="el-icon-document-copy" type="primary" style="margin-left:250px" @click="copytime">新增天数</el-button>
        <el-select v-if="new_msg_time.length>2" v-model="optionsvalue" clearable style="margin-left: 120px;" size="medium" filterable placeholder="回车确认选择天数" @keydown.enter.native="handleEnter">
          <el-option
            v-for="item in new_msg_time"
            :key="item.day"
            :label="item.day"
            :value="item.day"
          />
        </el-select>
        <el-button v-if="new_msg_time.length>2" type="info" style="margin-left: 10px;" @click="outdata">重置</el-button>
      </div>
      <div style="display:flex;">

        <div style="display:flex;flex-direction: column;">
          <div style="max-height: 600px;width: 500px; overflow-y: auto;">
            <div v-for="(content, index) in msg_time" :key="content.index">
              <div>
              <!-- <div class="ca_boxr">第{{ content.index }}天 </div> -->
              </div>
              <div class="copy_box">
                <div>
                  <div class="ca_boxr">第{{ content.index }}天 </div>
                </div>
                <el-button v-if="msg_time.length!=1" size="mini" icon="el-icon-delete" type="danger" plain @click="deletertime(index,content.index)" />
                <el-button size="mini" type="success" @click="tiemchooser(index,content.data,content.index)">时间段选择</el-button>
                <el-tag v-if="content.tiemlist==2" style="margin-left: 10px;" type="success">已选</el-tag>
              </div>

            </div>
          </div>
          <!-- class="sava_box" -->
          <div style="margin: 100px;">
            <el-button type="primary" @click="goback">返回</el-button>
            <el-button type="warning" :disabled="loadingtable" @click="saveclick">保存</el-button>
          </div>
        </div>
        <div style="margin-left: 50px;max-height: 600px; overflow-y: auto;">
          <!-- <el-tree :data="convertedData" :props="defaultProps" :default-expand-all="true" @node-click="handleNodeClick" /> -->
          <el-tree :data="convertedData" :props="defaultProps" :default-expand-all="true" @node-click="handleNodeClick">
            <template #default="{ node, data }">
              <div>
                <span :class="{ 'tree-first-level': node.level === 1 }">{{ node.label }}</span>
                <el-button v-if="data.button && data.button.show" style="margin-left:10px;" size="mini" type="primary" icon="el-icon-pie-chart" @click="look(data.button.sp_message_no)">预览</el-button>
              </div>
            </template>
          </el-tree>
        </div>
      </div>
    </el-form>

    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="25%"
    >
      <previewdialog ref="timepreview" />
    </el-dialog>
    <!-- 时间段选择 -->
    <el-drawer
      :title="`第${newtimeindex}天 时间段选择`"
      :visible.sync="timedialogVisible"
      :destroy-on-close="true"
      :destroy-on-click-modal="false"
      :modal-append-to-body="false"
      size="650px"
    >
      <timetactics ref="add" @tiemview="tiemview" />
    </el-drawer>
  </div>
</template>

<script>
import { spWorkWechatOpStrategyAdd, spWorkWechatOpStrategyupdate, spWorkWechatOpStrategyDetail } from '@/api/OperationStrategy.js'
import timetactics from './components/timetactics.vue'
// import choosetactics from './components/choosetactics.vue'
import { sprEnterprise } from '@/api/officialaccount.js'
import previewdialog from '../enterpmessagelist/components/previewdialog.vue'
export default {
  components: { previewdialog, timetactics },
  data() {
    return {
      // dialogVisible: false,
      timedialogVisible: false,
      sp_strategy_type: '1',
      sp_strategy_title: '',
      group_selection: 1,
      priwdialogVisible: false,
      push_method: '2',
      msg_timeindex: 2,
      msg_time: [
        {
          index: 1,
          tiemlist: '1' // 选择的消息
        }
      ],
      new_msg_time: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      cemsg_data: [{
        messages: [
          {
            timelist: '',
            sp_message_no: '',
            title: ''
          }
        ]
      }],
      chooseindex: null,
      sendmsgdata: [],
      timedata: [],
      ids: null,
      type: null,
      loadingtable: false,
      messageindex: null,
      messageindexr: null,
      subscribe_time_type: 0,
      consumption: 0, // 付费情况
      accountarrsa: [],
      sparr: [],
      timeindex: 0,
      convertedData: [],
      itemindex: '',
      optionsvalue: '',
      newtimeindex: 0
    }
  },
  async created() {
    // eslint-disable-next-line eqeqeq
    if (JSON.stringify(this.$route.query) == '{}') {
      // console.log(1, this.$route.query)
      this.ids = null
    } else {
      if (this.$route.query.accountarrsa === '[object Object]') {
        this.$router.go(-1)
        return
      }
      this.accountarrsa = this.$route.query.accountarrsa
      this.sparr = this.$route.query.sparr
      if (this.$route.query.type === 2) {
        this.ids = this.$route.query.id.id
        this.type = this.$route.query.type
        const row = await this.dataDetail(this.ids)
        // const row = this.$route.query.id
        console.log(111111, row)
        this.sp_strategy_title = row.title
        this.sp_strategy_type = row.trigger_type + ''
        this.push_method = row.send_type + ''
        // 时间转换
        Object.values(row.message).map((item, i) => {
          // this.optionsArr.push(item.day)
          console.log('this.optionsArr:', this.optionsArr)
          this.new_msg_time.push(item)
          if (item && i < this.new_msg_time.length) {
            console.log(1, item.time)
            this.msg_time.push({
              index: item.day,
              tiemlist: '2',
              data: item.time
            })
            this.msg_time = this.msg_time.filter(v => v.tiemlist !== '1')
            console.log('this.msg_time:', this.msg_time)
          } else if (item) {
            console.log(2)
          }
        })
        const lastIndex = this.new_msg_time.length - 1
        if (lastIndex >= 0) {
          const lastItem = this.new_msg_time[lastIndex]
          this.msg_timeindex = lastItem.day + 1
        } else {
          this.msg_timeindex = null
        }
        this.convertFormat()
      }
    }
  },
  mounted() {

  },
  methods: {
    convertFormat(newarr = this.new_msg_time) {
      // 排序
      this.new_msg_time.sort((a, b) => {
        const dayA = parseInt(a.day, 10) // 将字符串转换为整数
        const dayB = parseInt(b.day, 10) // 将字符串转换为整数
        return dayA - dayB
      })

      const output = []
      console.log(this.new_msg_time, 'this.new_msg_time')

      for (const item of newarr) {
        // console.log('item:', item)
        const dayItem = {
          label: `第${item.day}天`,
          children: []
        }

        for (const timeItem of item.time) {
          const timeRangeItem = {
            label: `时间段 ${timeItem.timeRange} 点`,
            children: []
          }

          for (const messageItem of timeItem.message) {
            let message = {}
            if (this.type === 2) {
              if (Array.isArray(messageItem)) {
                message = {
                  label: `消息id ${messageItem}`,
                  button: {
                    show: true,
                    sp_message_no: messageItem
                  }
                }
              } else if (typeof messageItem === 'object' && messageItem !== null) {
                if (messageItem.sp_message_no) {
                  message = {
                    label: `消息id ${messageItem.sp_message_no}`,
                    button: {
                      show: true,
                      sp_message_no: messageItem.sp_message_no
                    }
                  }
                } else {
                  message = {
                    label: `消息id ${messageItem}`,
                    button: {
                      show: true,
                      sp_message_no: messageItem
                    }
                  }
                }
              }
            } else {
              if (typeof messageItem === 'object' && messageItem !== null) {
                if (messageItem.sp_message_no) {
                  message = {
                    label: `消息id ${messageItem.sp_message_no}`,
                    button: {
                      show: true,
                      sp_message_no: messageItem.sp_message_no
                    }
                  }
                } else {
                  message = {
                    label: `消息id ${messageItem}`,
                    button: {
                      show: true,
                      sp_message_no: messageItem
                    }
                  }
                }
              }
            }
            timeRangeItem.children.push(message)
          }
          dayItem.children.push(timeRangeItem)
        }
        output.push(dayItem)
      }
      this.convertedData = output
      console.log('this.convertedData:', this.convertedData)
    },
    outdata() {
      this.optionsvalue = ''
      this.convertFormat()
    },
    handleEnter() {
      console.log('e:', this.optionsvalue)
      if (this.optionsvalue === '') {
        return
      }
      const filteredArray = this.new_msg_time.filter(item => {
        return this.optionsvalue === item.day
      })

      console.log(filteredArray)
      this.convertFormat(filteredArray)
      this.$message({
        type: 'success',
        message: '数据查找成功'
      })
    },
    handleNodeClick() {

    },
    // 点击确定
    async saveclick() {
      console.log(this.msg_time, this.new_msg_time)
      if (this.sp_strategy_title === '') {
        this.$message.error('请填写策略标题')
        return
      }
      let hasEmptyTime = false

      for (const itemr of this.msg_time) {
        // console.log('itemr.timelist:', itemr, itemr.tiemlist)
        // eslint-disable-next-line eqeqeq
        if (itemr.tiemlist == '1') {
          this.$message.error(`第 ${itemr.index} 天时间不能为空`)
          hasEmptyTime = true
          break // 跳出循环
        }
      }

      if (hasEmptyTime) {
        return
      }
      this.new_msg_time.forEach(v => {
        v.time.forEach(t => {
          t.message = t.message.map(s => s.sp_message_no)
        })
      })
      // console.log(this.new_msg_time)
      const data = {
        id: this.type === 2 ? this.ids : null,
        title: this.sp_strategy_title,
        trigger_type: this.sp_strategy_type,
        send_type: this.push_method,
        config_json: this.new_msg_time
        // sp_message_nos: this.sendmsgdata
      }
      // console.log(data, this.ids, '-0-0-')
      try {
        this.type === 2 ? await spWorkWechatOpStrategyupdate(data) : await spWorkWechatOpStrategyAdd(data)
        this.$router.go(-1)
        this.optionsvalue = ''
      } catch (error) {
        this.$router.go(-1)
        this.optionsvalue = ''
      }
    },
    async dataDetail(id) {
      const res = await spWorkWechatOpStrategyDetail({ id })
      return res.data
    },
    // 时间确定
    tiemview(item) {
      console.log('item:', item, this.timeindex, this.newtimeindex)
      this.timedialogVisible = false
      // console.log('item:', item, this.timeindex, this.msg_time)
      const index = this.timeindex + 1
      this.itemindex = ''
      this.msg_time.map(c => {
        // console.log('c:', c)
        if (index === c.index) {
          this.itemindex = c.index
          c.tiemlist = '2'
          c.data = item// time
        } else {
          console.log('you lai zhe l ', c)
          if (this.newtimeindex === c.index) {
            this.itemindex = c.index// 不确定
            c.tiemlist = '2'
            c.data = item// time
          }
        }
      })
      if (this.itemindex !== '') {
        // console.log(11)
        this.new_msg_time.forEach(v => {
          // console.log(v, v.index, this.timeindex)
          console.log('v.day:', v.day, this.timeindex, this.newtimeindex)
          if (v.day === this.timeindex + 1) {
            console.log('lai zhe =1')
            this.new_msg_time.splice(this.timeindex, 1)
          } else if (v.day === this.newtimeindex) {
            console.log('lai zhe')
            this.new_msg_time.splice(this.timeindex, 1)
          }
        })
        console.log('   bu s')
        this.new_msg_time.push({
          day: this.itemindex,
          time: item
        })
      } else {
        console.log('lai zhe l ')
        this.new_msg_time.push({
          day: this.newtimeindex,
          time: item
        })
      }
      this.convertFormat()
    },
    copytime() {
      if (this.msg_time.length < 30) {
        this.msg_time.push({
          index: this.msg_timeindex++,
          tiemlist: '1'
        })
      } else {
        this.$message({
          type: 'error',
          message: '已达到最大数量'
        })
      }
    },
    deletertime(index, id) {
      console.log('index, id:', index, id)
      console.log('index:', index, id, this.new_msg_time, this.msg_time)
      this.$confirm(`您确定删除第${id}天吗？`)
        .then(async() => {
          this.msg_time.splice(index, 1)
          if (this.timeindex >= this.msg_time.length) {
            this.timeindex = this.msg_time.length - 1
          }
          this.new_msg_time.filter(s => {
            if (s.day === id) {
              console.log(2222, s.day, id)
              this.new_msg_time.splice(index, 1)
              // this.new_msg_time.push(s)
              this.convertFormat()
            } else {
              console.log('who')
            }
          })
          console.log(this.new_msg_time, ' this.new_msg_time')
          // this.convertFormat()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        })
        .catch(() => {})
    },
    tiemchooser(i, item, index) {
      console.log('item:', item)
      this.timeindex = i
      this.newtimeindex = index
      this.timedialogVisible = true
      if (Array.isArray(item)) {
        console.log(111)
        this.newtimeViewArr = []
        item.tiemlist || this.$nextTick(() => {
          this.$refs.add.sendr(item, 2, this.type)
        })
      } else if (typeof item === 'object' && item !== null) {
        this.$nextTick(() => {
          const arr = [item]
          this.$refs.add.sendr(arr, 2, this.type, this.push_method, this.ids)
        })
      }
      // this.$nextTick(() => {
      // })
    },
    chooserr(index, indexr) {
      this.messageindex = index
      this.messageindexr = indexr
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosetacticsview.send(2)
      })
    },
    deleter(index) {
      console.log(this.msg_data)
      this.msg_data.splice(index, 1)
    },

    deleterr(index) {
      this.cemsg_data.splice(index, 1)
    },
    spchangerr() {
      this.msg_data.forEach((item) => {
        item.message_name = ''
        item.sp_message_no = ''
      })
    },
    goback() {
      this.$router.go(-1)
    },
    async look(id) {
      const data = await sprEnterprise({
        sp_message_no: id
      })
      console.log('data', data.data)
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(data.data)
      }, 100)
    },
    copycirculate() {
      this.cemsg_data.push({
        day_numbers: '',
        messages: [
          {
            sp_message_no: '',
            title: '',
            cycle_type: 4,
            hour: '',
            minute: ''
          }
        ]
      })
    },
    deletercirculate(index, indexr) {
      this.cemsg_data[index].messages.splice(indexr, 1)
    }
  }
}
</script>

<style scoped>
/* @import url(); 引入css类 */
::v-deep .el-tree-node__content{
  margin: 10px 0;
}
.stra_box{
  width: 300px;
}
.copy_box{
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  padding-left: 34px;
}
.copy_boxr{
  margin:0 0 20px 100px;
  display: flex;
  align-items: center;
}
.taewr{
  display: flex;
  align-items: center;
  }
.tiwmebox{
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  border-left: 0px;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 0px 5px 5px 0px;
  }
  .tiwmeboxr{
    width: 50px;
    background: #f4f7f7;
    height: 36px;
    border: 1px solid #cccccc;
    text-align: center;
    line-height: 36px;
    color: #61686b;
    border-radius: 5px;
  }
  .ca_boxr{
    margin-right: 17px;
    width: 50px;
    text-align: left;
    color: rgb(169, 162, 151);
    font-size: 14px;
    font-weight: 700;
  }
  .tree-first-level {
  background-color: #13ce66; /* 设置背景色 */
  color: #f4f7f7;
  padding: 3px !important;
}
  .ca_boxre{
    width: 50px;
    text-align: right;
    margin-right:16px;
    color: rgb(169, 162, 151);
    font-size: 14px;
    font-weight: 700;
  }
  ::v-deep input::-webkit-outer-spin-button,
  ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  .el-form-item--medium .el-form-item__label{
    line-height:36px;
  }
  @media (max-width: 768px){

  }

  ::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
    }
    .tactics_box{
      padding: 20px 20px 40px 20px;
    }
    .sum_box{
      position: fixed;
      left: 0;
      bottom: -20px;
      margin-left: 30px;
    }
    .sava_box{
      position: fixed;
      bottom: 250px;
      left: 286px;
    }

    .senadtime{
      display: flex;
      align-items: center;
    }

</style>
